<div *ngIf="resolutionNote.attachments.total" class="media-container" [class.wide]="class">
  <div *ngFor="let attachment of resolutionNote.attachments.all; let i = index"
       class="attachment-container">
    <div class="attachment-border">
      <div class="attachment">
        <img *ngIf="attachment.type === 'image'" [src]="attachment.src" alt=""
             [gallery]="'attachments-gallery'"
             [lightbox]="attachment.galleryIndex">
        <video *ngIf="attachment.type === 'video'" [src]="attachment.src"
               [gallery]="'attachments-gallery'"
               [lightbox]="attachment.galleryIndex"></video>
        <div *ngIf="attachment.type === 'document'" class="attachment-document" (click)="downloadAttachment(attachment.id, i)">
          <div class="attachment-document-icon">
            <mat-icon *ngIf="!isDownloading.includes(i)">file_present</mat-icon>
            <mat-icon *ngIf="isDownloading.includes(i)" class="loading">autorenew</mat-icon>
          </div>
        </div>
        <div class="attachment-actions">
          <mat-icon matTooltip="Rotate left 90 degrees"
                    *ngIf="(authenticationService.user$ | async)?.permissions?.includes('tasks.update') && attachment.type === 'image'"
                    (click)="rotatePhoto('counter-clockwise', attachment.id, i);$event.stopImmediatePropagation()">
            rotate_left
          </mat-icon>
          <mat-icon matTooltip="Rotate right 90 degrees"
                    *ngIf="(authenticationService.user$ | async)?.permissions?.includes('tasks.update') && attachment.type === 'image'"
                    (click)="rotatePhoto('clockwise', attachment.id, i);$event.stopImmediatePropagation()">
            rotate_right
          </mat-icon>
          <mat-icon matTooltip="Delete attachment"
                    *ngIf="!task.closed_at && (authenticationService.user$ | async)?.permissions?.includes('tasks.update')"
                    (click)="deleteAttachment('media', attachment.id);$event.stopImmediatePropagation()">
            delete
          </mat-icon>
        </div>
      </div>
    </div>
    <div class="attachment-details">
      <div class="attachment-filename" [matTooltip]="attachment.original_filename">{{ attachment.original_filename }}</div>
      <div class="attachment-size">{{ attachment.size }}</div>
    </div>
    <fury-loading-overlay [isLoading]="isRotatingPhoto.includes(i)" [fill]="true"></fury-loading-overlay>
  </div>
</div>
